export function formatDuration(seconds) {
  if (seconds === undefined || seconds === null) return "";
  const minutes = Math.floor(seconds / 60);
  const secs = String(seconds % 60).padStart(2, "0");
  return `[${minutes}:${secs}]`;
}

const SEGUE_SPLIT_REGEX = /\s*(?:->|>|→|⇒)\s*/;

function normalizeTitle(title) {
  return title
    ?.replace(/[“”]/g, '"')
    ?.replace(/[’]/g, "'")
    ?.trim()
    ?.toLowerCase();
}

export function splitSegueSegments(pattern) {
  if (!pattern) return [];
  return pattern
    .split(SEGUE_SPLIT_REGEX)
    .map((segment) => segment.trim())
    .filter(Boolean);
}

function parseSimplePattern(pattern) {
  if (!pattern) return { from: null, to: null };
  const parts = splitSegueSegments(pattern);
  if (parts.length >= 2) {
    return { from: parts[0], to: parts[1] };
  }
  return { from: parts[0] || null, to: null };
}

function createSegueResult(pattern, sourceTrack) {
  return {
    showArrow: true,
    title: pattern ? `Segue: ${pattern}` : "Segue into next track",
    isLottery: sourceTrack?.segue_type === "lottery_ticket",
  };
}

export function getSegmentIndex(track, segments) {
  if (!track || !segments.length) return -1;

  if (
    track.segue_position &&
    track.segue_position >= 1 &&
    track.segue_position <= segments.length
  ) {
    return track.segue_position - 1;
  }

  const normalizedTrackTitle = normalizeTitle(track.title);
  return segments.findIndex(
    (segment) => normalizeTitle(segment) === normalizedTrackTitle
  );
}

export function getSegueInfo(track, nextTrack) {
  if (!track) return null;

  const trackPattern = track?.segue_pattern;
  const groupId = track?.segue_group_id;
  const nextGroupId = nextTrack?.segue_group_id;
  const inSameChain =
    groupId &&
    nextGroupId &&
    groupId === nextGroupId &&
    (typeof track?.segue_position !== "number" ||
      typeof nextTrack?.segue_position !== "number" ||
      nextTrack.segue_position > track.segue_position);

  const segments = splitSegueSegments(trackPattern);
  if (segments.length > 1) {
    const segmentIndex = getSegmentIndex(track, segments);
    const hasNextSegment =
      segmentIndex >= 0 && segmentIndex < segments.length - 1;

    if (hasNextSegment && nextTrack) {
      const current = segments[segmentIndex];
      const normalizedTrackTitle = normalizeTitle(nextTrack.title);

      for (let i = segmentIndex + 1; i < segments.length; i++) {
        const candidate = segments[i];
        if (normalizeTitle(candidate) === normalizedTrackTitle) {
          return createSegueResult(`${current} -> ${candidate}`, track);
        }
      }

      if (inSameChain) {
        const nextLabel = segments[segmentIndex + 1] || nextTrack.title;
        return createSegueResult(`${current} -> ${nextLabel}`, track);
      }
    }
  }

  if (nextTrack) {
    const nextPattern = nextTrack?.segue_pattern;
    const parsedNext = parseSimplePattern(nextPattern);
    const matchesPrevious =
      nextPattern && parsedNext.from
        ? normalizeTitle(parsedNext.from) === normalizeTitle(track.title)
        : false;

    if (matchesPrevious) {
      return createSegueResult(nextPattern, nextTrack);
    }

    const nextSegments = splitSegueSegments(nextPattern);
    if (
      nextSegments.length > 1 &&
      nextTrack?.segue_position &&
      nextTrack.segue_position > 1
    ) {
      const prevSegment = nextSegments[nextTrack.segue_position - 2];
      if (
        normalizeTitle(prevSegment) === normalizeTitle(track.title) &&
        nextTrack.segue_position <= nextSegments.length
      ) {
        const current =
          nextSegments[nextTrack.segue_position - 1] || nextTrack.title;
        return createSegueResult(
          `${prevSegment} -> ${current}`,
          nextTrack
        );
      }
    }

  }

  return null;
}

export function getDisplayTitle(track) {
  return track?.title || "";
}
